import * as builder from "./builder";

export const eshop = { builder };